import { observer } from "mobx-react";
import { SelectDropdown } from "../../../../../../../../components/inputs/select-dropdown/select-dropdown";
import currentPortalStore from "../../../../../../../../stores/current-portal-store";
import { RESOLUTION_TYPE } from "../../../../../../constants";
import resolutionListStore from "../../../../../../stores/resolution-list-store";
import { RefundTypeProps } from "../refund-type-props";

const RefundType: React.FC<RefundTypeProps> = observer(({resolution, validationGroup}) => {
    const platform = currentPortalStore.platform;
    const refundTypes = resolutionListStore.settings.refund_types.filter(option => platform?.isResolutionSupportedByType(option.value as RESOLUTION_TYPE));
    const selectedRefundType = () => {
        if (resolution?.instantRefundProvider !== null) {
            return refundTypes.find(type => (type.value as unknown) === RESOLUTION_TYPE.InstantRefundType);
        }
        return refundTypes.find(type => (type.value as unknown) === resolution?.resolutionType);
    };

    return (
        <SelectDropdown
            value={selectedRefundType()}
            options={refundTypes}
            onChange={(v) => {
                if (v) {
                    resolution?.setResolutionType(v.value as RESOLUTION_TYPE);
                }
            }}
            required
            validationGroup={validationGroup} />
    );
});

export default RefundType;